import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../utils/useTranslation';
import { BusinessUI } from '../business/types';
import { IconProduct } from '../icon/IconProduct';
import { IconProductOutline } from '../icon/IconProductOutline';
import { Button } from '../input/Button';
import { FlexProps } from '../layout/Flex';

export interface CatalogButtonProps extends FlexProps {
    business: BusinessUI;
    onClick: VoidFunction;
    outlineIcon?: boolean;
    hideText?: boolean;
}

export const CatalogButton: FC<CatalogButtonProps> = ({
    business,
    onClick,
    outlineIcon,
    hideText,
    ...props
}) => {
    const t = useTranslation();

    if (!business.catalogUrl) {
        return null;
    }

    const Icon = outlineIcon ? IconProductOutline : IconProduct;

    return (
        <Button
            as={Link}
            to={business.catalogUrl}
            variant="filled"
            color="secondary"
            onClick={onClick}
            spacing={1}
            {...props}
        >
            <Icon size={outlineIcon ? 16 : 20} />
            {hideText ? null : t(business.catalogTitle)}
        </Button>
    );
};
